import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'not-found-page',
    templateUrl: './not-found-page.component.html',
    styleUrls: ['./not-found-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class NotFoundPageComponent  {}



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/app/shared/not-found/not-found-page.component.ts